import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import BannerImage from './images/banner.png';

import * as Config from '../../../Config';

const { Text, Title } = Typography;

const Banner = () => {
    return (
        <div>
            {/* Banner */}
            <Row align='middle' style={{ padding: '4rem 0rem 4rem 0rem' }}>
                <Col
                    xs={{ span: 24, order: 2 }}
                    lg={{ span: 10, offset: 2, order: 1 }}
                >
                    <Col style={{ padding: '2rem' }}>
                        <Title style={{ fontSize: '44px' }}>
                            Take control of your day
                        </Title>
                        <Text style={{ fontSize: '20px' }}>
                            Jot down your day to day activities, emotions and
                            plans, check back later, learn and improve your
                            productivity.
                        </Text>
                    </Col>
                    <Col xs={24} sm={18} lg={12} style={{ padding: '2rem' }}>
                        <Button
                            block
                            type='primary'
                            size='large'
                            // shape='round'
                            icon={<LoginOutlined />}
                            onClick={() => {
                                const returnTo = window.location.origin;
                                window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(returnTo)}`;
                            }}
                        >
                            Login to your Account
                        </Button>
                    </Col>
                </Col>
                <Col
                    xs={{ span: 24, order: 1 }}
                    lg={{ span: 10, order: 2 }}
                    style={{ padding: '0 2rem' }}
                >
                    <img src={BannerImage} alt='<app_name>' width='100%' />
                </Col>
            </Row>
        </div>
    );
};

export default Banner;
